import { Directive, inject, input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[i18nInterpolate]',
})
export class I18nInterpolateDirective {
  readonly templateRef = inject(TemplateRef);
  readonly slot = input.required<string>({ alias: 'i18nInterpolate' });
}
